<template>
	<div class="modal-card">
		<div class="edit-modal-content">
			<div class="title">
				<span>
					Categoria
				</span>
				<button
					class="close-icon"
					type="button"
					@click="closeModal"
				>
					<img
						src="/static/img/icon-close.svg"
						alt="cerrar modal"
						height="24px"
						width="24px"
					>
				</button>
			</div>
			<div class="section">
				<div class="wrapper-input">
					<label 
						for="category"
						class="label-modal">
						Categoria
					</label>
					<select
						name="category"
						id="category"
						class="select-modal"
						v-model="categoryId"
						:disabled="disabledSelect"
					>
						<option value="">Seleccione una categoria</option>
						<option 
							v-for="(category, index) in categories"
							:key="index"
							:value="category.id">{{category.title}}</option>
					</select>
				</div>
				<div class="wrapper-input wrapper-flex">
					<div class="wrapper-input-modal">
						<label 
							for="name"
							class="label-modal">
							Nombre
						</label>
						<input 
							type="text"
							class="form-input"
							id="name"
							v-model="newCategory.title"
						>
					</div>
					<button 
						:class="[
							'btn-more',
							incompleteCategoryInfo ? 'disable-class' : null
						]"
						type="button"
						@click="addCategory"
						:disabled="incompleteCategoryInfo"
						>
						<img 
							src="/static/img/icon-plus.svg" 
							alt="Subir imagen" 
							height="20px" 
							width="20px"
							v-if="!checked">
						<img 
							src="/static/img/checked.svg" 
							alt="checked"
							height="20px" 
							width="20px"
							v-if="checked">
					</button>
				</div>
				<div class="wrapper-input">
					<label 
						for="description"
						class="label-modal">
						Descripcion
					</label>
					<textarea 
						id="description" 
						cols="30" 
						rows="10"
						class="form-input textarea-modal-categories"
						v-model="newCategory.description"
					>
					</textarea>
				</div>
				<div class="wrapper-input">
					<label 
						for="description"
						class="label-modal">
						Orden
					</label>
					<input 
						:disabled="!disabledSelect"
						id="order" 
						class="form-input"
						v-model="newCategory.order" />
				</div>
				<div class="wrapper-input-upload">
					<upload-image
						label-for="category-id"
						label-ref="category-image"
						:visible-more="false"
						:url-image="newCategory.image"
						@send-image="getImage"
					/>
				</div>
				<div class="wrapper-result-categories">
					<div
						v-for="(list, index) in categories"
						:key="index">
						<div class="wrapper-group-categories">
							<div class="wrapper-categories">
								<p class="text-categories"><span class="text-bold">Categoría: </span>{{list.title}}</p>
								<div>
									<button 
										type="button"
										@click="editCategories(list)">
										<img 
											src="/static/img/icon-edit-dark.svg" 
											alt="editar"
											height="18px">
									</button>
									<button 
										type="button"
										@click="deleteCategories(index, list)">
										<img 
											src="/static/img/icon-close-dark.svg" 
											alt="eliminar"
											height="18px">
									</button>
								</div>
							</div>
						</div>
						<div v-if="list.subCategories">
							<div 
								v-for="(sub, indexSub) in list.subCategories.data" 
								:key="indexSub">
								<div class="wrapper-group-categories">
									<div class="wrapper-categories">
										<div class="wrapper-overflow">
											<p class="text-categories"><span class="text-bold">Categoría: </span>{{list.title}}</p>
											<p class="text-categories"><span class="text-bold">Sub Categoría: </span>{{sub.title}}</p>
										</div>
										<div>
											<button 
												type="button"
												@click="editCategories(sub)">
												<img 
													src="/static/img/icon-edit-dark.svg" 
													alt="editar"
													height="18px">
											</button>
											<button 
												type="button"
												@click="deleteCategories(indexSub, sub, index)">
												<img 
													src="/static/img/icon-close-dark.svg" 
													alt="eliminar"
													height="18px">
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<button 
					:class="[
						'btn-save',
						incompleteCategoryInfo ? 'disable-class' : null
					]"
					@click="addCategory"
					type="button"
					:disabled="incompleteCategoryInfo"
					>
					Guardar
				</button>
			</div>
		</div>
	</div>
</template>
<script>
import orderBy from 'lodash/orderBy';
import lib from '@/shared/lib';
import uploadImage from '@/components/commons/upload-image';

const { removeItemFromArrayByIndex, compose, setNewProperty } = lib;

function created() {
	this.loadCategories();
}

async function loadCategories() {
	const url = `${process.env.ARIS_URL}/app/${process.env.APP_CODE}/categories`;
	const { data: categories } = await this.$http.get(url);
	this.categories = categories.data;
	this.$emit('update-categories', orderBy(this.categories, 'order'));
}

function closeModal() {
	this.cleanForm();
	this.$emit('close-modal');
}

async function addCategory() {
	const id = this.newCategory.id;
	const urlPost = `${process.env.ARIS_URL}/edit/categories`;
	const urlPut = `${process.env.ARIS_URL}/edit/categories/${id}`;
	const url = id ? urlPut : urlPost;
	const method = id ? 'put' : 'post';
	const body = this.buildBody(this.newCategory);
	await this.$http[method](url, body);
	this.cleanForm();
	this.loadCategories();
	this.checked = false;
	this.disabledSelect = false;
}

function cleanForm() {
	this.newCategory = {
		description: '',
		id: 0,
		image: '',
		title: '',
		order: 0,
	};
	this.categoryId = '';
}

function editCategories(category) {
	this.newCategory.description = category.description;
	this.newCategory.image = category.image;
	this.newCategory.title = category.title;
	this.newCategory.id = category.id;
	this.newCategory.order = category.order || 0;
	this.categoryId = category.categoryParentId || '';
	this.disabledSelect = !!category.flagParent;
	this.checked = true;
	this.$emit('update-categories', orderBy(this.categories, 'order'));
}

async function deleteCategories(index, { id }, indexInitial = '') {
	if (indexInitial !== '') {
		this.categories[indexInitial].subCategories.data.splice(indexInitial, 1);
	} else {
		this.categories = removeItemFromArrayByIndex(index, this.categories);
	}
	await this.$http.delete(`edit/categories/${id}`);
	this.$emit('update-categories', this.categories);
}

function buildBody(category) {
	const flagParent = !this.categoryId;
	return compose(
		setNewProperty('title', category.title),
		setNewProperty('subTitle', '...'),
		setNewProperty('link', '...'),
		setNewProperty('linkUrl', '...'),
		setNewProperty('linkText', '...'),
		setNewProperty('flagActive', true),
		setNewProperty('order', category.order),
		setNewProperty('description', category.description),
		setNewProperty('image', [category.image]),
		setNewProperty('codeApp', process.env.APP_CODE),
		setNewProperty('flagParent', flagParent),
		setNewProperty('categoryId', this.categoryId),
	)({});
}

function getImage(image) {
	this.newCategory.image = image;
}

function incompleteCategoryInfo() {
	const name = !!this.newCategory.title;
	const description = !!this.newCategory.description;
	return !(name && description);
}

function data() {
	return {
		categories: [],
		checked: false,
		newCategory: {
			description: '',
			id: 0,
			image: '',
			title: '',
			order: 0,
		},
		categoryId: '',
		disabledSelect: false,
		flagEdit: false,
	};
}

export default {
	name: 'category-form',
	components: {
		uploadImage,
	},
	computed: {
		incompleteCategoryInfo,
	},
	created,
	data,
	methods: {
		addCategory,
		buildBody,
		cleanForm,
		closeModal,
		deleteCategories,
		editCategories,
		getImage,
		loadCategories,
	},
};
</script>
<style lang="scss" scoped>
.modal-card {
	background-color: white;
	margin-top: 230px;

	@media (min-width: 964px) {
		margin-top: 150px;
	}
}

.title {
	align-items: center;
	background-color: map-get($colors, black-dark);
	color: white;
	display: flex;
	height: 50px;
	justify-content: space-between;
	padding: 0 15px;
}

.close-icon {
	align-items: center;
	display: flex;
}

.section {
	padding: 10px 20px;
}

.btn-more {
	background-color: map-get($colors, black-dark);
	border-radius: 4px;
	height: 30px;
	margin-left: 15px;
	padding: 5px 0px;
	vertical-align: sub;
	width: 30px;
}

.wrapper-flex {
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
}

.wrapper-input-modal {
	width: 85%;
}

.textarea-modal-categories {
	height: 84px;
	margin-bottom: 17px;
}

.wrapper-result-categories {
	max-height: 219px;
	overflow: scroll;
}

.wrapper-group-categories {
	border-top: 1px solid map-get($colors, outline-products);
	padding-top: 10px;
}

.wrapper-categories {
	align-items: center;
	border-radius: 4px;
	border: 1px solid map-get($colors, grey-list);
	display: flex;
	height: 60px;
	justify-content: space-between;
	overflow: hidden;
	padding: 0 18px;
	width: 100%;
}

.wrapper-input-upload {
	margin-bottom: 10px;
}

.btn-save {
	background: map-get($colors, black-dark);
	color: #fff;
	display: block;
	margin: 42px auto;
	padding: 13px 35px;
}

.disable-class {
	cursor: not-allowed;
	opacity: 0.25;
}

.select-modal {
	height: 40px;
	margin-bottom: 10px;
	outline: none;
	width: 100%;
}

.wrapper-overflow {
	max-height: 100%;
	overflow: scroll;
}
</style>




// WEBPACK FOOTER //
// src/components/commons/category-form.vue